import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { AuthUser } from './auth.state';

export const AuthActions = createActionGroup({
    source: 'Auth',
    events: {
        'Init Auth':                emptyProps(),
        'Restore Session':          props<{ token: string; user: AuthUser }>(),
        'Login':                    props<{ email: string; password: string }>(),
        'Login Success':            props<{ token: string; user: AuthUser }>(),
        'Login Failure':            props<{ error: string }>(),
        'Logout':                   emptyProps(),
        'Session Expired':          emptyProps(),
        'Load Permissions':         emptyProps(),
        'Load Permissions Success': props<{ permissions: unknown[] }>(),
        'Load Permissions Failure': props<{ error: string }>(),
    }
});
